// extracted by mini-css-extract-plugin
export default {"body":"Header_body__ZNXcx","head":"Header_head__lP0il"};